import ko from "knockout";
import { closePopups, openPopup } from "../init";

export enum PopupStatus { Open = 'open', Close = 'close' }
export const isPopupOpen = (status: PopupStatus): boolean => status === PopupStatus.Open;
export const togglePopup = (popupId: string, status: PopupStatus) => isPopupOpen(status)
    ? openPopup(popupId)
    : closePopups();

export class PopupModel {
    title: KnockoutObservable<string>;
    content: KnockoutObservable<string>;
    buttonText: KnockoutObservable<string>;
    buttonLoading: KnockoutObservable<boolean>;
    clickHandler: KnockoutObservable<(() => void)>;

    constructor(title: string, content: string, buttonText: string) {
        this.title = ko.observable<string>(title);
        this.content = ko.observable<string>(content);
        this.buttonText = ko.observable<string>(buttonText);
        this.buttonLoading = ko.observable<boolean>(false);
        this.clickHandler = ko.observable<(() => void)>();
    }

    click() {
        this.clickHandler()();
    }

    configure(options: Partial<{
        title: string;
        content: string;
        buttonText: string;
        buttonLoading: boolean;
        clickHandler: () => void;
    }>): void {
        Object.entries(options).forEach(([key, value]) => {
            if (value === undefined) {
                return;
            }

            const observable = (this as any)[key];
            if (ko.isObservable(observable)) {
                observable(value);
            }
        });
    }
}
